import { UrlUtil } from "@core/utils/url-util";
import { EnvironmentsAppName } from "./typings"
import { BusinessException } from "@core/error"
import { PageCacheKey } from "@modules/basic/page";

/**
 * 系统环境变量定义
 */
let envConfig = {
    /**
     * 获取外部系统的根路径，只要不是本项目内的地址，都要使用这个获取
     * 
     * @summary 如果没有你需要的外部系统名称，则需要在apps中添加
     * @param {EnvironmentsAppName} name 外部系统名称
     * @returns 路径地址
     */
    appPath: function (name?: EnvironmentsAppName): string {
        const origin = window?.location.origin ? window.location.origin : `${window.location.protocol}//${window.location.host}`;
        const path = window?.location?.pathname || "/";
        const stageChar = path.match(/(^(\/stage)?)/gi);
        const rootPath = origin + stageChar;
        if (stageChar != undefined && stageChar != null) {
            if (name && name.toString() != "") {
                return rootPath + "/" + this.apps[name];
            } else {
                return rootPath;
            }
        }

        throw new BusinessException("A00001");
    },
    /**
     * 外部系统名称
     * 
     * @summary 如果没有你需要的外部系统名称，则需要添加
     */
    apps: {
        base: "cgp-rest",
        file: "file",
        oauth: "qpson-social-login",
        whitelabel: "whitelabel-site"
    },
    /**
     * 获取外部系统的路径，只要不是本项目内的地址，都要使用这个获取
     * 
     * @param {EnvironmentsAppName} appName 外部系统名称
     * @param path 
     * @returns 
     */
    getPath(appName: EnvironmentsAppName | "", path: string) {
        let aName = this.appPath(appName);

        if (aName.endsWith("/")) {
            aName = aName.substring(-1);
        }

        return [aName, path].join("/");
    },
    /**
     * 获取fileService app路径
     */
    getFileAppPath() {
        // const fileServiceDomainName = process.env.FILE_SERVICE_DOMAIN_NAME!;

        // if (envConfig.isStage()) {
        //     return UrlUtil.joinUrl([fileServiceDomainName, "stage", this.apps["file"]]);
        // }

        // return UrlUtil.joinUrl([fileServiceDomainName, this.apps["file"]]);
        // const fileServiceDomainName = window?.location.origin ? window.location.origin : `${window.location.protocol}//${window.location.host}`;
        // const path = window?.location?.pathname || "/";
        // if (/(^\/stage?)/gi.test(path)) {
        //     return UrlUtil.joinUrl([fileServiceDomainName, "stage", this.apps["file"]]);
        // }
        // return UrlUtil.joinUrl([fileServiceDomainName, this.apps["file"]]);

        return envConfig.appPath("file");
    },
    // SnapShop域名
    // snapShopDomian: process.env.SNAP_SHOP_DOMIAN,
    // SnapShop入口地址
    // snapShopEntryUrl: process.env.SNAP_SHOP_ENTRY_URL,
    /**
     * SnapShop域名
     * @returns 
     */
    getSnapShopDomian: function (): string {
        if (envConfig.isStage()) {
            return process.env.SNAP_SHOP_DOMIAN_STAGE!;
        }

        return process.env.SNAP_SHOP_DOMIAN!;
    },
    /**
     * SnapShop入口地址
     * @returns 
     */
    getSnapShopEntryUrl: function (): string {
        if (envConfig.isStage()) {
            return process.env.SNAP_SHOP_ENTRY_URL_STAGE!;
        }

        return process.env.SNAP_SHOP_ENTRY_URL!;
    },
    wooCommerecePath: "https://wordpress.org/plugins/",
    shopifyPath: "https://apps.shopify.com/",
    /**
     * 获取本项目内的页面路径，不是本项目内的页面请用getPath方法获取
     * @param rootPath 根路径
     * @param pagePath 页面相对于根目录的路径
     * @returns 
     */
    getInnerPage(rootPath: string, pagePath?: string): string {
        let url = rootPath;
        if (pagePath) {
            url = rootPath + ((rootPath.lastIndexOf("/") == rootPath.length - 1 || pagePath.indexOf("?") == 0) ? "" : "/") + pagePath;
        }

        return url;
    },
    /**
     * 首页域名地址
     * @param rootPath 根路径
     * @returns 
     */
    getHomePage(rootPath: string): string {
        if (ENV_IS_QPMN) {
            return this.appPath() + "/";
        }

        return rootPath;
    },
    getBrowserVersion(browserType: string, platform: "mobile" | "pc"): number {
        const optionStr = process.env.BROWSER_CONFIG;
        const browserOptions = eval("(" + optionStr + ")");
        if (platform === "mobile") {
            return browserOptions.MOBILE_BROWSER[browserType] ?? 1;
        } else {
            return browserOptions.PC_BROWSER[browserType] ?? 1;
        }
    },
    /**
     * 订单分类状态配置
     */
    orderCategory: {
        // 所有订单
        all: {
            filter: "",
            status: [40, 41, 42, 43, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 111, 112, 113, 114, 115, 200, 202, 203, 300, 301, 400, 401, 402, 224098, 224101, 240710]
        },
        // 进行中
        inProgress: {
            filter: "",
            status: [100, 104, 106, 107, 300, 301, 224098, 102, 9358697],
        },
        // 完成的
        completed: {
            filter: "",
            status: [224101]
        },
        // 取消的
        canceled: {
            filter: "",
            status: [41, 42]
        }
    },
    /**
     * 默认分页大小
     */
    defaultPageSize: 20,
    /**
     * int最大值，不限制分页大小时，也可以取这个值
     */
    maximumNumber: 2147483647,
    /**
     * UI动作对应的的流程Key
     */
    ActionKey: {
        // 快递单号 ActionKey
        expressAction: "COMMIT_EXPRESS_INFO",
        // 取消退货 ActionKey,
        cancelReturn: "CANCEL_RETURN_REQUEST"
    },
    /**
     * 网站支持邮箱
     */
    supportEmail: process.env.SUPPORT_EMAIL!,
    /**
     * 网站服务邮箱
     */
    serviceEmail: process.env.SERVICE_EMAIL!,
    /**
     * google recaptcha公钥
     */
    googleRecaptchaSecretKey() {
        if (envConfig.isStage()) {
            return process.env.GOOGLE_SECRET_KEY_STAGE!;
        }
        
        return process.env.GOOGLE_SECRET_KEY!;
    },
    /**
     * Sentry配置
     */
    sentry: {
        dsnConfigs: {
            secret: process.env.SENTRY_DSN_SECRET!,
            secret_stage: process.env.SENTRY_DSN_SECRET_STAGE!,
            id: process.env.SENTRY_DSN_ID!,
            id_stage: process.env.SENTRY_DSN_ID_STAGE!,
            appName: "sentry"
        },
        // 希望过滤的错误，支持字符串或正则
        ignoreErrors: [/token/gi],
        // 希望过滤的地址，目前本地错误均不发送sentry
        blacklistUrls: [/localhost/gi],
        //可以设置以下属性：tags,extras,level,如需要扩展，需要修改sentry.service.js。
        scopeConfigs: {
            //默认配置不可以删除
            GLOBAL: {
                //tag和extras中可以使用@module变量，值为运行时传入的moduleName
                tags: { module: '@module' },
            },
            RESTFUL_RESOLVE: {
                tags: { module: 'rest.service' },
                extras: { errorType: 'resolved' },
            },
            RESTFUL_REJECT: {
                tags: { module: 'rest.service' },
                extras: { errorType: 'rejected' },
            }
        },
        // 错误类型，目前已设置网络请求中200类型错误与非200错误
        errorType: {
            RESOLVE: 'resolved',
            UNRESOLVE: 'unresolved',
            REJECT: 'rejected',
        }
    },
    /**
     * google 第三方授权公钥
     */
    googleOAuth2ClientId: process.env.GOOGLE_OAUTH2_CLIENT_ID !,

    /**
     * paypal clientId
     */
    getPaypalClientId() {
        if (envConfig.isStage()) {
            return process.env.PAYPAL_CLIENT_ID_STAGE!;
        }

        return process.env.PAYPAL_CLIENT_ID!;
    },
    // 判断是否带有stage标识
    isStage(): boolean {
        const path = window?.location?.pathname || "/";
        const hostname = window?.location?.hostname || "/";

        if (/^\/stage/gi.test(path) || /^stage/gi.test(hostname)) {
            return true;
        }

        return false;
    },
    /**
     * shopify平台url
     */
    shopifyPlatformUrl: process.env.SHOPIFY_PLATFORM_URL!,
    
    /**
     * paypal平台url
     */ 
    paypalPlatformUrl: process.env.PAYPAL_PLATFORM_URL!,
    
    /**
     * 网站shopifyApp安装地址
     */
    siteShopifyAppInstallUrl: process.env.SITE_SHOPIFY_APP_INSTALL_URL!,
    
    /**
     * 物流单号查询url
     */
    orderTrackUrl: process.env.ORDER_TRACK_URL!,
    
    /**
     * app名: qpmn或qpson
     */    
    APP_NAME: process.env.APP_NAME!,
    
    /**
     * appTag: a环境还是b环境
     */ 
    APP_TAG: process.env.APP_TAG!,
    
    /**
     * appLanguage: 网站默认使用语言
     */ 
    APP_LANGUAGE: process.env.APP_LANGUAGE!,
    
    /**
     * default: 网站默认使用货币
     */ 
    DEFAULT_CURRENCY: "USD",
    
    /**
     * 获取Etsy店铺授权地址
     */
    getEtsyAuthorizeUrl() {
        const key: PageCacheKey = "Token";
        const storageItem = window.localStorage.getItem(process.env.APP_STORAGE_CODE! + "-" + key);
        // const isStage = envConfig.isStage();
        // const etsyAuthUrlPrefix = isStage ? process.env.ETSY_AUTHORIZE_URL_STAGE! : process.env.ETSY_AUTHORIZE_URL!;

        // if (storageItem) {
        //     return `${etsyAuthUrlPrefix}auth/stores/${storageItem}/authorize`;
        // }

        // return `${etsyAuthUrlPrefix}auth/stores/0/authorize`;

        return envConfig.appPath("base") + "/api/v2/stores/connect/etsy" + "?" + `access_token=${storageItem}`;
    },
    
    /**
     * 店铺订单是否跳转新拼单页
     */
    isJumpNewBulkOrderPage: false,
}


export { envConfig }